import React, { FC, useEffect, useState } from "react"
import _ from 'lodash'
import Isvg from 'react-inlinesvg'
import { RouteComponentProps, Link } from "@reach/router"
import { navigate } from '@reach/router'
// Components
import { Toolbar } from "components/subnav"
import ComparisonDetailView from "components/asset-management/comparison/detail/comparison-detail-view"
// Data
import api_match from "data/interface/api"
import keyService, * as chord from "data/key"
import comparisonService, { Comparison } from "data/comparison"
// Styles
import { HeaderIcon_s } from 'components/wrapper/header/header-styles'
import { DetailedRouteUpDown_s, DetailedUpDownBtn_s } from "components/table/data-table-styles"
// Icons
import { CaretRightIcon, BackArrowIcon } from 'images/icons/general/'
import { CaretDownIcon, CaretUpIcon } from "images/icons/tools/"

const ComparisonDetail: FC<RouteComponentProps> = (props) => {
  const [currentComparison, setCurrentComparison] = useState<Comparison|null>(null)
  const [comparisons, setComparisons] = useState<Comparison[]|null>(null)

  useEffect(() => {
    const comparisonSubscription = comparisonService.stream().subscribe(data => {
      if (data.state === "ok"){
        setComparisons(data.value)
        setCurrentComparison(_.find(data.value, {comparisonid: _.toNumber(_.get(props, "comparisonId"))}))
      }
    })

    comparisonService.fetchComparisons()

    return function cleanup() {
      comparisonSubscription.unsubscribe()
    }
  }, [_.get(props, "comparisonId")])

  useEffect(() => {
    const keySubscription = keyService.stream().subscribe(k => {
      switch(true) {
        case k.chord === chord.CTRL_SHIFT_UP && k.down === true:
          toggleComparison('up')
          break
        case k.chord === chord.CTRL_SHIFT_DOWN && k.down === true:
          toggleComparison('down')
          break
        case k.chord === chord.CTRL_SHIFT_BACK && k.down === true:
          navigate('/n/asset-management/comparison')
      }
    })

    return function cleanup() {
      keySubscription.unsubscribe()
    }
  })

  function toggleComparison(direction:string):void {
    const currentComparisonIdx       = comparisons?.indexOf(currentComparison!);
    let   nextComparison:Comparison|null = null
    if (direction === 'up' && comparisons){
      nextComparison = comparisons && comparisons[currentComparisonIdx! - 1]
    } else {
      nextComparison = comparisons && comparisons[currentComparisonIdx! + 1]
    }
    if (nextComparison) setCurrentComparison(nextComparison)
    nextComparison && comparisonService.fetch(nextComparison['comparisonid'])
    navigate(`/n/asset-management/comparison/${_.get(nextComparison, "comparisonid")}`)
  }

  const upDisabled   = !comparisons || _.isNil(comparisons[comparisons.indexOf(currentComparison!) - 1]) || (!_.isNil(comparisons) && currentComparison && comparisons[comparisons.indexOf(currentComparison!) - 1]['systeminput']?.startsWith('system'))
  const downDisabled = !comparisons || _.isNil(comparisons[comparisons.indexOf(currentComparison!) + 1]) || (!_.isNil(comparisons) && currentComparison && comparisons[comparisons.indexOf(currentComparison!) + 1]['systeminput']?.startsWith('system'))

  return (
    <div>
      <Toolbar>
        <div>
          <Link to="/n/asset-management/comparison">
            <HeaderIcon_s style={{marginRight: '5px'}}><Isvg src={BackArrowIcon} /></HeaderIcon_s>
            Comparison
          </Link>
          <DetailedRouteUpDown_s>
            <DetailedUpDownBtn_s id="detailedRouteRecordUp" disabled={upDisabled} onClick={()=>toggleComparison('up')}><Isvg src={CaretUpIcon} /></DetailedUpDownBtn_s>
            <DetailedUpDownBtn_s id="detailedRouteRecordDown" disabled={downDisabled} onClick={()=>toggleComparison('down')}><Isvg src={CaretDownIcon} /></DetailedUpDownBtn_s>
          </DetailedRouteUpDown_s>
          <div>{_.get(currentComparison, "code")}</div>
        </div>
      </Toolbar>
      { currentComparison && <ComparisonDetailView currentComparison={currentComparison}/> }
    </div>
  )

}

export default ComparisonDetail
